

import { useGetDataStartup } from '../composables/getData.js'
import { useConnectionStore } from '../stores/connectionStore';
import { useRouter } from 'vue-router';

// check startup info every 6 hours
const STARTUP_CHECK_INTERVAL = 21600

function processStartupJsonResponse (json,afterProcessingCallbackRoutine) {
  //console.log(" in callback from startup",json)
  if (json.hasOwnProperty('error')) {
    alert("ERROR while running -> " + json['programRun'] + "\n\n" + json['error'])
    return;
  }

  const connectionStore = useConnectionStore()

  const isMe = json['isme']
  const canPerpetual = json["can_perpetual"]
  const isSubscriber = json['sp']
  const subscriberExpireDisplayString = json['expdate']
  const subscriberExpireDate = json['expires']
  const coordinateLocation = json['coor']
  const verified = json['verified']         // y/n

  const timeNow = Math.floor(Date.now() / 1000)

  connectionStore.setCoordinateLocation(coordinateLocation)
  connectionStore.setIsSubscriber(isSubscriber)
  connectionStore.setSubscriberExpireDate(subscriberExpireDate)
  connectionStore.setSubscriberExpireDisplayString(subscriberExpireDisplayString)
  connectionStore.setLastStartupDate(timeNow)

  connectionStore.setEmailVerified(verified)

  connectionStore.setIsMe(isMe)
  connectionStore.setCanPerpetual(canPerpetual)

  const lichessAccessToken = json['t']
  const lichessUserid = json['u']

  //console.log("*** access token in startup",lichessAccessToken,lichessUserid)

  connectionStore.setLichessAccessToken(lichessAccessToken) 
  connectionStore.setLichessUserid(lichessUserid)

  if (afterProcessingCallbackRoutine != undefined)
    afterProcessingCallbackRoutine(true)
}

export const doStartupCheck = (force,afterProcessingCallbackRoutine) => {
  const connectionStore = useConnectionStore()
  var lastStartupCheck = connectionStore.getLastStartupCheckDate

  const timeNow = Math.floor(Date.now() / 1000)

  if (force)
    lastStartupCheck = 0
  //console.log("TIME NOW ",timeNow,lastStartupCheck)

  // no need to call server, but still need to call the callback routine
  if (timeNow - lastStartupCheck <= STARTUP_CHECK_INTERVAL) {
    //console.log("startup no need to check server", afterProcessingCallbackRoutine)
    if (afterProcessingCallbackRoutine != undefined)
      afterProcessingCallbackRoutine(false)
    return;
  }

  var formData = {
      locale : "",
      transtype : "P",
      lasttrans : "0"  }

  //console.log("in doStartupCheck",formData,afterProcessingCallbackRoutine)
  useGetDataStartup("getweb4_verbal_startup_info.php", formData, 
                  processStartupJsonResponse,afterProcessingCallbackRoutine)

}

